
import { useEffect } from 'react';

const SmoothScroll = () => {
    useEffect(() => {
        // [DISABLED] - User requested to comment out Lenis effect
        /*
        const lenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            orientation: 'vertical',
            gestureOrientation: 'vertical',
            smoothWheel: true,
        });

        function raf(time: number) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }

        requestAnimationFrame(raf);

        return () => {
            lenis.destroy();
        };
        */
    }, []);

    return null;
};

export default SmoothScroll;
